module.exports = __webpack_public_path__ + "static/media/chatting.9ae780c0.svg";